export function download(binaryData: ArrayBuffer, fileType: string, fileName: string): void {
    
    const file: Blob = new Blob([binaryData], {type: fileType});
    const url: string = window.URL.createObjectURL(file);
    const anchorElement: HTMLAnchorElement = document.createElement('a');
    anchorElement.download = fileName;
    anchorElement.href = url;
    anchorElement.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

}